import { apiUserAttempts } from "../../services/Login";
import { apiRegisterPayU } from "../../services/Register";
import {
  REGISTER_PAYU_SUCCESS,
  REGISTER_PAYU_FAIL,
  REGISTER_PAYU_LOADING,
  REGISTER_PAYU_WARNING,
  REGISTER_PAYU_BLOCKED,
  REGISTER_PAYU_UNBLOCK
} from "../reducers/RegisterPayUReducers";

const _REGISTER_PAYU_LOADING = () => ({
  type: REGISTER_PAYU_LOADING,
  payload: { data: null, error: null },
});

const _REGISTER_PAYU_UNBLOCK = () => ({
  type: REGISTER_PAYU_UNBLOCK,
  payload: { data: null, error: null },
});

const _REGISTER_PAYU_SUCCESS = (data) => ({
  type: REGISTER_PAYU_SUCCESS,
  payload: {
    data,
    error: null,
  },
});

const _REGISTER_PAYU_FAIL = (error) => ({
  type: REGISTER_PAYU_FAIL,
  payload: {
    error,
    data: null,
  },
});

const _REGISTER_PAYU_WARNING = (data) => ({
  type: REGISTER_PAYU_WARNING,
  payload: {
    data,
    error: null,
  },
});

const _REGISTER_PAYU_BLOCKED = (data) => ({
  type: REGISTER_PAYU_BLOCKED,
  payload: {
    data,
    error: null,
  },
});

export const registerPayUAction = (registerForm, mail, modal, navigate) => (dispatch) => {
  dispatch(_REGISTER_PAYU_LOADING());
  apiUserAttempts({ email: mail, action: "POST", type: "token" })
    .then(any => {
      if (any.data.data.user_message) {
        dispatch(_REGISTER_PAYU_WARNING(any.data.data.user_message));
      }
      apiRegisterPayU(registerForm)
        .then((res) => {
          if (!res.data.success) {
            return dispatch(_REGISTER_PAYU_FAIL(res.data.error.user_message));
          }
          dispatch(_REGISTER_PAYU_SUCCESS(res.data));
        })
        .catch((error) => {
          if (error.response.status === 500) {
            return dispatch(_REGISTER_PAYU_FAIL("Error interno"));
          }
          dispatch(_REGISTER_PAYU_FAIL(error.response.data.error.user_message));
        });
    })
    .catch((error) => {
      if(modal){
        return dispatch(_REGISTER_PAYU_FAIL(error.response.data.error.user_message))
      }
      dispatch(_REGISTER_PAYU_BLOCKED(error.response.data.error.user_message));
    });
};

export const validationErrorPayUAction = (error) => (dispatch) => dispatch(_REGISTER_PAYU_FAIL(error));
export const registerUnblockAction = () => (dispatch) => dispatch(_REGISTER_PAYU_UNBLOCK());
